export default (amount = 0) =>
  amount > 999 ? `${parseFloat((amount / 1000).toFixed(2))}K` : amount;
